import { Alert, Button, Modal, Spin } from 'antd';
import { observer } from 'mobx-react-lite';
import * as React from 'react';
import { DocumentSelectionStep } from '.';
import { TestProjectDataStore, TestProjectWizardStore } from '../stores';

type Props = {
    wizardStore: TestProjectWizardStore;
    testProjectDataStore: TestProjectDataStore;
};

const TestProjectBaselinesUpdateDialog: React.FC<Props> = ({ wizardStore, testProjectDataStore }) => {
    const [errorMessage, setErrorMessage] = React.useState<string | null>(null);

    const capturedTestProjectDataStore = wizardStore.testProjectDataStore;
    const isEditingProject = wizardStore.isEditingProject(testProjectDataStore);

    const handleCancel = () => {
        wizardStore.setBaselinesEditDialogVisible(false);
        wizardStore.resetBaselineSwitch();
        setErrorMessage(null);
    };

    const handleSave = () => {
        if (!isEditingProject || !wizardStore.canEditProject) {
            return;
        }

        if (wizardStore.newPackagesForBaselineSwitch.length === 0) {
            setErrorMessage('Please select at least one document!');
        } else {
            setErrorMessage(null);
            wizardStore
                .switchBaselinesForPackage()
                .then(successful => {
                    if (successful) {
                        if (wizardStore.testProjectDataStore === capturedTestProjectDataStore) {
                            handleCancel();
                        }

                        testProjectDataStore.loadTestProject();
                        testProjectDataStore.loadTestProjectBaselines();
                    }
                })
                .catch(() => {
                    // Do nothing
                });
        }
    };

    return (
        <Modal
            visible={wizardStore.baselinesEditDialogVisible && isEditingProject}
            title={'Edit documents for baselines'}
            onCancel={handleCancel}
            maskClosable={false}
            centered
            destroyOnClose
            width={850}
            footer={[
                <Button
                    key="save-packages"
                    type="primary"
                    onClick={handleSave}
                    disabled={!wizardStore.canEditProject}
                    size="large"
                >
                    Save
                </Button>
            ]}
        >
            {errorMessage && <Alert message={errorMessage} style={{ marginBottom: 12 }} type="error" />}
            {wizardStore.testProjectLoadError && (
                <Alert
                    message={wizardStore.testProjectLoadError}
                    type="error"
                    action={<Button onClick={wizardStore.retryTestProjectSetup}>Retry</Button>}
                />
            )}
            {wizardStore.isSettingUpTestProject && <Spin />}
            {wizardStore.canEditProject && (
                <DocumentSelectionStep
                    store={wizardStore}
                    selectedPackages={wizardStore.newPackagesForBaselineSwitch}
                    setSelectedPackages={wizardStore.setNewPackagesForBaselineSwitch}
                    skipPackageLoading
                />
            )}
        </Modal>
    );
};

export default observer(TestProjectBaselinesUpdateDialog);
